import { render, staticRenderFns } from "./StudyConversationMessageEditorTextDesktop.vue?vue&type=template&id=83fff06a&scoped=true"
import script from "./StudyConversationMessageEditorTextDesktop.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageEditorTextDesktop.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageEditorTextDesktop.vue?vue&type=style&index=0&id=83fff06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fff06a",
  null
  
)

export default component.exports